import React from 'react';
import loc from 'owa-localize';
import { observer } from 'owa-mobx-react';
import { shyHeader, shyHeaderOverlay, shyHeaderGripper } from './OwaHeaderShyBar.scss';
import { shyHeaderAriaLabel } from '../OwaHeader.locstring.json';

interface OwaHeaderShyBarProps {
    onMouseDown: () => void;
    onFocus: () => void;
}

const defaultExport: React.FunctionComponent<OwaHeaderShyBarProps> = observer(
    function OwaHeaderShyBar(props: OwaHeaderShyBarProps) {
        const { onMouseDown, onFocus } = props;

        return (
            <div
                className={shyHeader}
                tabIndex={0}
                onMouseDown={onMouseDown}
                onFocus={onFocus}
                aria-label={loc(shyHeaderAriaLabel)}
                role="button"
            >
                <div className={shyHeaderOverlay} />
                <div className={shyHeaderGripper} />
            </div>
        );
    },
    'OwaHeaderShyBar'
);

export default defaultExport;
